import { render, staticRenderFns } from "./PanZoomComponent.vue?vue&type=template&id=2ca58b8b"
import script from "./PanZoomComponent.vue?vue&type=script&lang=js"
export * from "./PanZoomComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports